import DataTable from "datatables.net-dt";
import languageUK from 'datatables.net-plugins/i18n/uk.mjs';

export default (initial = {}) => ({
    schemaUrl: initial.schemaUrl ?? '',
    dataUrl:   initial.dataUrl ?? '',
    saveUrl:   initial.saveUrl ?? '',
    deleteUrl: initial.deleteUrl ?? '',
    pageLength: initial.pageLength ?? 20,

    dt: null,
    columns: [],
    optionsFromServer: {},
    saving: false,

    form: {
        id: null,
        course_id: null,
        department_id: null,
        months_interval: 1,
        iterations_total: ''
    },

    async boot() {
        const schema = await fetch(this.schemaUrl, { credentials:'same-origin' }).then(r=>r.json());
        this.columns = (schema.columns || []).map(c => this.mapColumn(c));
        this.optionsFromServer = schema.options || {};
        this.initTable();
        this.bindRowActions();
    },

    mapColumn(col) {
        if (col.type === 'actions') {
            col.orderable = false;
            col.searchable = false;
            col.render = (_, __, row) => row.actions ?? '';
        }
        return col;
    },

    initTable() {
        this.dt = new DataTable(this.$refs.dataTable, {
            processing: true,
            serverSide: true,
            pageLength: this.pageLength,
            language: {
                ...languageUK,
                infoFiltered: '',
            },
            fixedHeader: true,
            responsive: true,
            scrollX: true,
            autoWidth: true,
            ajax: { url: this.dataUrl, type: 'GET' },
            columns: this.columns.map((col) => {
                if (col.data === 'course_name') {
                    return {
                        ...col,
                        render: function (data, type, row) {
                            const url = row['course_link'];
                            return `<a href="${url}" target="_blank" title="${data}">${data}</a>`;
                        }
                    };
                }

                if (col.data === 'progress') {
                    return {
                        ...col,
                        orderable: false,
                        searchable: false,
                        render: function (_data, _type, row) {
                            const progress = row.progress || {};
                            const percent = Math.max(0, Math.min(100, Number(progress.percent) || 0));
                            const label = progress.label || `${progress.completed ?? 0} / ${progress.total ?? '∞'}`;

                            return `
                                <div class="c-auto-assign-progress">
                                    <div class="c-auto-assign-progress__bar" style="background:#E2E8F0;border-radius:4px;height:8px;overflow:hidden;">
                                        <span style="display:block;height:100%;background:#38A169;width:${percent}%;"></span>
                                    </div>
                                    <div class="c-auto-assign-progress__label" style="margin-top:4px;font-size:12px;color:#1A202C;">
                                        ${label}
                                    </div>
                                </div>
                            `;
                        }
                    };
                }

                return col;
            }),
            ...this.optionsFromServer
        });
    },

    reload() { this.dt?.ajax.reload(null, false); },

    bindRowActions() {
        document.addEventListener('click', async (e) => {
            const btn = e.target.closest('button[data-action]');
            if (!btn) return;
            const id = parseInt(btn.dataset.id || '0', 10);
            const action = btn.dataset.action;

            if (action === 'delete') {
                if (!confirm('Видалити правило?')) return;
                const fd = new FormData(); fd.append('id', id);
                const res = await fetch(this.deleteUrl, { method:'POST', credentials:'same-origin', body: fd }).then(r=>r.json());
                if (!res.success) return alert(res.data?.message || 'Помилка');
                this.reload();
            }

            if (action === 'fill') {
                const row = this.dt?.row(btn.closest('tr'))?.data();
                if (!row) return;
                this.form = {
                    id: row.id,
                    course_id: parseInt(row.course_id,10),
                    department_id: parseInt(row.department_id,10),
                    months_interval: parseInt(row.months_interval,10),
                    iterations_total: row.iterations_total === null ? '' : parseInt(row.iterations_total,10),
                };
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });
    },

    async save() {
        this.saving = true;
        const fd = new FormData();
        Object.entries(this.form).forEach(([k,v]) => fd.append(k, v ?? ''));

        const res = await fetch(this.saveUrl, {
            method:'POST', credentials:'same-origin', body: fd
        }).then(r=>r.json());
        this.saving = false;

        if (!res.success) return alert(res.data?.message || 'Не збережено');

        if (!this.form.id) {
            this.form.course_id = null;
            this.form.department_id = null;
            this.form.months_interval = 1;
            this.form.iterations_total = '';
        }
        this.reload();
    },
});
